import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default ({ user, disabled }) => {
  const [dateOrBirth, setDateOfBirth] = useState(new Date(user.date_of_birth));
  const handleChange = (date) => {
    setDateOfBirth(new Date(date));
  };
  const handleChangeRow = (e) => {
    const regex = /^[0-9\/]*$/;
    const value = e.target.value;
    const length = value.length;
    if (length >= 11 || !regex.test(value)) {
      e.preventDefault();
    }
    if (value.includes("/")) {
      const splittedDate = value.split("/");
      const dayMonth = splittedDate[0] + "/" + splittedDate[1];
      const year = splittedDate[2];
      const currentYear = new Date().getFullYear();
      if (year > currentYear) {
        e.target.value = dayMonth + "/" + currentYear;
      }
    }
  };
  return (
    <div className="form-row">
      <div className="col-100 col-md-25 d-flex align-items-center">
        <label className="m-0">Date Of Birth</label>
      </div>
      <div className="col-100 col-md-75">
        <ReactDatePicker
          wrapperClassName="form-control"
          className="form-control"
          placeholderText="Date of birth MM/DD/YYYY"
          disabled={disabled}
          id="date_of_birth"
          name="date_of_birth"
          selected={dateOrBirth}
          onChange={handleChange}
          maxDate={new Date()}
          onChangeRaw={handleChangeRow}
        />
      </div>
    </div>
  );
};
